
import React from 'react';

import ObjectInfoValues from '../ObjectInfoValues';

const IsknTelInfo = ({isknDate, data}) => {

    const tel = data.tel[0];

    return (
        <React.Fragment>
            <ObjectInfoValues items={[
                {
                    title: 'Katastrální území',
                    value: `${tel.katuze_name} (${tel.katuze_kod})`
                },
                {
                    title: 'Číslo LV',
                    value: `${tel.cislo_tel}`
                }
            ]}/>
        </React.Fragment>
    );
}

export default IsknTelInfo;
